<template>
  <div class="page-work">
    <section class="hero-section hero-section--right">
      <section class="hero-section__content-wrapper">
        <section class="hero-section__content">
          <section class="hero-section__control">
            <div class="slope">
              <svg x="0px" y="0px" viewBox="0 0 140.5 225">
                <line style="fill: none;
                  stroke: #000000;
                  stroke-miterlimit: 10;" x1="134" y1="4.7" x2="8.9" y2="219.1" />
              </svg>
            </div>
            <transition name="fade">
              <div v-if="loaded" class="arrow prev" @click="prevProject" v-touch="prevProject">
                <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Prev Project" />
              </div>
            </transition>
            <transition name="fade">
              <div v-if="loaded" :class="{
                'arrow next': true,
                disabled: currentProjectIndex != -1 ? false : true,
              }" @click="nextProject" v-touch="nextProject">
                <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Next Project" />
              </div>
            </transition>
          </section>
          <transition name="fade-delay">
            <section v-if="desc" class="hero-section__text">
              <h1 class="hero-section__title">_{{ title }}</h1>
              <article class="desc" v-html="desc"></article>
              <div class="arrow down" v-scroll-to="scrollDownTarget">
                <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Next Project" />
              </div>
            </section>
          </transition>
        </section>
      </section>
      <section class="hero-section__media-wrapper">
        <section class="hero-section__media">
          <div v-if="heroMediaType == 'image'" :class="{
            'hero-section__image-container': true,
            'has-link': heroMediaLink != '' ? true : false,
          }" @click="imageLink(heroMediaLink)">
            <v-lazy-image class="hero-section__image" :src="heroMedia.sizes['1536x1536']" />
          </div>
          <template v-if="heroMediaType == 'video'">
            <section class="hero-section__video">
              <div class="hero-section__iframe-container" style="padding:75% 0 0 0;position:relative;"
                v-html="parseVideo(heroMedia)"></div>
            </section>
          </template>
        </section>
      </section>
    </section>
    <section class="bottom-part">
      <section v-for="(layout, i) in bottomParts" :key="`layout-${i}`"
        :class="`bottom-part__layout ${layout.acf_fc_layout}`">
        <template v-if="layout.acf_fc_layout == 'hero_media'">
          <section :class="{
            'hero-section': true,
            'hero-section--left': !layout.align_to,
            'hero-section--right': layout.align_to,
          }">
            <section class="hero-section__content-wrapper">
              <div v-if="i == layoutsLength" class="arrow up desktop-only" @click="scrollToTop">
                <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Go to top" />
              </div>
              <section :class="{
                'hero-section__content': true,
                'has-tag': layout.tag ? true : false,
              }">
                <div class="hero-section-tag__container" v-if="layout.tag">
                  <span :class="{
                    'font-size-sm':
                      serializeTag(layout.tag).length > 15 ? true : false,
                  }" v-html="serializeTag(layout.tag)">
                  </span>
                </div>
                <section v-if="layout.description_toggle" class="hero-section__text">
                  <h1 class="hero-section__title">
                    _<span v-text="layout['title_&_description'].title
                        ? layout['title_&_description'].title
                        : title
                      "></span>
                  </h1>
                  <article class="hero-section__desc" v-html="layout['title_&_description'].description"></article>
                </section>
              </section>
            </section>
            <section class="hero-section__media-wrapper">
              <section class="hero-section__media">
                <div v-if="layout.media_type == 'image'" :class="{
                  'hero-section__image-container': true,
                  'has-link': heroMediaLink != '' ? true : false,
                }" @click="imageLink(layout.image_link)">
                  <v-lazy-image class="hero-section__image" :src="layout.hero_image.sizes['1536x1536']" />
                </div>
                <template v-if="layout.media_type == 'video'">
                  <section class="hero-section__video">
                    <div class="hero-section__iframe-container" style="padding:75% 0 0 0;position:relative;"
                      v-html="parseVideo(layout.hero_video)"></div>
                  </section>
                </template>
                <div v-if="i == layoutsLength && !layout.layout" class="arrow up mobile-only mx-auto"
                  @click="scrollToTop">
                  <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Go to top" />
                </div>
              </section>
            </section>
          </section>
        </template>
        <template v-if="layout.acf_fc_layout == 'image_set'">
          <section :class="{
            'image-set__container': true,
            'image-set--left': !layout.layout,
            'image-set--right': layout.layout,
          }">
            <section class="image-set__left">
              <section class="image-set-image__container">
                <v-lazy-image :src="layout.images[0].sizes['medium_large']" />
                <v-lazy-image :src="layout.images[1].sizes['medium_large']" class="mb-0" />
                <div v-if="i == layoutsLength && !layout.layout" class="arrow up desktop-only" @click="scrollToTop">
                  <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Go to top" />
                </div>
              </section>
              <div class="image-set-tag__container">
                <svg x="0px" y="0px" viewBox="0 0 83 900" style="enable-background:new 0 0 83 900;">
                  <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 53.1035 2.0498)" text-anchor="end"
                    v-html="serializeTag(layout.tag)"></text>
                </svg>
              </div>
            </section>
            <section class="image-set__right">
              <section class="image-set-image__container">
                <div class="image-dot-container">
                  <v-lazy-image :src="layout.images[2].sizes['medium_large']" @load="showDots = true" />
                  <transition name="fade">
                    <img v-if="showDots" class="image-set-dots" src="@/assets/img/image-set-dots.png" width="228"
                      height="119" />
                  </transition>
                </div>
                <div v-if="i == layoutsLength && layout.layout" class="arrow up" @click="scrollToTop">
                  <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Go to top" />
                </div>
              </section>
              <div v-if="i == layoutsLength && !layout.layout" class="arrow up mobile-only mx-auto" @click="scrollToTop">
                <img src="@/assets/img/arrow.svg" width="30px" height="auto" alt="Go to top" />
              </div>
            </section>
          </section>
        </template>
      </section>
    </section>
  </div>
</template>

<script>
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
import _ from "lodash";
export default {
  data() {
    return {
      title: "",
      heroMediaType: "",
      heroMedia: "",
      heroMediaLink: "",
      desc: "",
      bottomParts: "",
      justifyControl: "",
      loaded: false,
      showDots: false,
      scrollDownTarget: {
        el: ".bottom-part",
        duration: 1200,
        easing: "ease-out-quart",
      },
      windowWidth: "",
    };
  },
  mounted() {
    // gsap.timeline({
    // // yes, we can add it to an entire timeline!
    // scrollTrigger: {
    //   trigger: ".image-set__right",
    //   pin: true,   // pin the trigger element while active
    //   start: "top top", // when the top of the trigger hits the top of the viewport
    //   end: "+=500", // end after scrolling 500px beyond the start
    //   scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //   snap: {
    //     snapTo: "labels", // snap to the closest label in the timeline
    //     duration: {min: 0.2, max: 3}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
    //     delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
    //     ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
    //   }
    // }
    // });
    this.$nextTick(() => {
      this.$store.commit("mutateShownAll");

      this.loadData();
      if (!this.projects.length) {
        this.loadProjects();
      }
      this.onResize();
      window.addEventListener("resize", this.onResize);
    });
  },
  computed: {
    showNextArrow() {
      return true;
      // if (this.currentProjectIndex >= this.projectLength) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    layoutsLength() {
      return this.bottomParts.length - 1;
    },
    projects() {
      return this.$store.state.projects;
    },
    projectLength() {
      return this.$store.getters.projectLength;
    },
    currentProjectIndex() {
      return this.$store.getters.currentProjectIndex;
    },
  },
  watch: {
    windowWidth(newWidth) {
      if (newWidth < 768) {
        this.scrollDownTarget.el = ".hero-section__media-wrapper";
      } else {
        this.scrollDownTarget.el = ".bottom-part";
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    swipeHandler(swipe) {
      if (swipe === "left") {
        this.nextProject();
      } else {
        this.prevProject();
      }
    },
    scrollToTop() {
      this.$scrollTo("body", 0);
      // this.$scrollTo(".page-work", 1200, {
      //   easing: "ease-in-out-quart",
      // });
    },
    imageLink(url) {
      if (url && url != "") window.open(url, "_blank");
    },
    loadProjects() {
      const api =
        `${process.env.VUE_APP_API_DOMAIN}/wp-json/wp/v2/project/?per_page=50&orderby=menu_order`;
      this.axios.get(api).then((response) => {
        for (const data of response.data) {
          const item = {
            title: _.get(data, "title.rendered"),
            slug: _.get(data, "slug"),
          };
          this.projects.push(item);
        }
        this.$store.commit("mutateProjects", this.projects);
        this.$store.commit("mutateProjectsLoaded", true);
      });
    },
    loadData() {
      this.$scrollTo("body", 0);
      const api = `${process.env.VUE_APP_API_DOMAIN}/wp-json/wp/v2/project/?slug=${this.$route.params.slug}`;
      this.axios
        .get(api)
        .then((response) => {
          if (response.data.length) {
            const data = response.data[0];
            this.$store.commit("mutateCurrentProjectSlug", _.get(data, "slug"));
            const heroMediaType = _.get(data, "acf.Hero_media.media_type");
            this.title = _.get(data, "title.rendered");
            this.heroMediaType = heroMediaType;
            this.heroMedia = _.get(data, `acf.Hero_media.${heroMediaType}`);
            if (heroMediaType == "image")
              this.heroMediaLink = _.get(data, `acf.Hero_media.image_link`);
            this.desc = _.get(data, "acf.desc");
            this.bottomParts = _.get(data, "acf.bottom_part");
            this.loaded = true;
          } else {
            this.$router.push({ name: "Home", hash: "#home" });
          }
        })
        .catch((error) => {
          console.log("error:", error);
          this.$router.push({ name: "Home", hash: "#home" });
        })
        .then(() => {
          // const body = document.querySelector("body");
          // body.scrollTo(0, 0);
        });
    },
    prevProject() {
      this.$store.dispatch("actionPageTransition", "fade-in-left").then(() => {
        if (this.currentProjectIndex > 0) {
          const prev = this.currentProjectIndex - 1;
          if (this.projects.length) {
            const target = this.projects[prev];
            if (
              this.$route.name != "Work" ||
              this.$route.params.slug != target.slug
            )
              this.$router.push({
                name: "Work",
                params: { slug: target.slug },
              });
          }
        } else if (this.currentProjectIndex == 0) {
          this.$router.push({ name: "Home", hash: "#work" }).catch(() => {
            return null;
          });
        } else {
          this.$router.go(-1);
        }
      });
      // if (this.currentProject > 0) {
      //   const prev = this.currentProject - 1;
      //   this.$store.commit("mutateCurrentProject", prev);
      // }
      // this.$router.push({ name: "Work", params: { slug: target.slug } });
    },
    nextProject() {
      this.$store.dispatch("actionPageTransition", "fade-in-right").then(() => {
        const next = this.currentProjectIndex + 1;
        if (this.projects.length) {
          const target = this.projects[next];
          if (
            this.$route.name != "Work" ||
            this.$route.params.slug != target.slug
          )
            this.$router.push({ name: "Work", params: { slug: target.slug } });
        }
      });
    },
    parseVideo(v) {
      return v
        .replace('width="520" height="390"', "")
        .replace(
          "dnt=1&amp;app_id=122963",
          "autoplay=0&title=0&byline=0&portrait=0"
        );
    },
    serializeTag(val) {
      const output = [];
      for (const tag of val) {
        output.push(tag.name);
      }
      return output.join(", ");
    },
  },
};
</script>

<style lang="scss">
$image-set-bg-color: #f4f5ef;
$image-set-bg-color-vitae: #f5e7e6;
$align-to-logo-margin: calc((100vw - 1180px) * 0.5 + 75px);

.page-work {
  padding-top: 200px;
}

.fade-delay-enter-active,
.fade-delay-leave-active {
  transition: opacity 0.5s;
  transition-delay: 0.3s;
}

.fade-delay-enter,
.fade-delay-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.v-lazy-image {
  width: 100%;
  height: auto;
  opacity: 0;
  transition: opacity 0.4s cubic-bezier(0.25, 1, 0.5, 1);
}

.v-lazy-image-loaded {
  opacity: 1;
}

// Hero Section
.hero-section {
  display: flex;
  min-height: 670px;

  * {
    font-family: "Cormorant Infant";
    font-weight: 500;
  }
}

.hero-section__control {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-right: 10px;
}

.hero-section__control .arrow {
  position: absolute;
}

.hero-section__control .prev {
  // display: inline-flex;
  // justify-self: left;
  left: 0;
}

.hero-section__control .next {
  // display: inline-flex;
  // justify-self: right;
  right: 0;
}

.arrow {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.arrow.next {
  transform-origin: center;
  transform: rotate(180deg);
}

.arrow {
  transition: opacity 0.4s ease-out;
}

.arrow.disabled {
  opacity: 0.2;
  cursor: progress;
}

.arrow.down>* {
  transform-origin: center;
  transform: rotate(-90deg);
}

.image-set__container .arrow.up {
  margin-top: 20px;
}

.arrow.up>* {
  transform-origin: center;
  transform: rotate(90deg);
  // margin-top: 20px;
  margin-bottom: 40px;
}

.slope {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
}

// align right
.hero-section--right {
  .hero-section__content-wrapper {
    flex: 0 1 38%;
  }

  .hero-section__media-wrapper {
    flex: 1 0 62%;
  }

  // Hero section text
  .hero-section__content {
    // width: 100%;
    width: auto;
    height: 100%;
    max-width: 350px;
    margin-left: $align-to-logo-margin;
  }

  .hero-section__text {
    margin-top: 15%;
    padding: 40px 20px 40px 40px;
  }
}

.bottom-part .hero-section--right {
  .hero-section__content {
    max-width: 350px;
  }

  .hero-section__content.has-tag {
    width: 100%;
    max-width: 100%;
  }

  .arrow.up {
    position: absolute;
    margin-left: $align-to-logo-margin;
    margin-top: 40px;
    z-index: 9;
  }
}

.bottom-part .hero-section--left .hero-section__media {
  width: auto;
  margin-left: $align-to-logo-margin;
}

// align left
.hero-section--left {
  flex-direction: row-reverse;

  .hero-section__content-wrapper {
    flex: 0 0 350px;
  }

  .hero-section__media-wrapper {
    flex: 1 1 62%;
    // margin-left: $align-to-logo-margin;
  }

  // Hero section text
  .hero-section__content {
    margin-top: 15%;
    width: 100%;
    max-width: 350px;
  }

  .hero-section__text {
    padding-left: 30px;
    padding-right: 50px;
  }
}

.hero-section__content-wrapper {
  position: relative;
}

.hero-section__content {
  position: absolute;
}

.bottom-part>.bottom-part__layout>.hero-section.hero-section--left {
  margin-top: 100px;
}

.bottom-part .hero-section__content {
  max-width: unset;
  height: 100%;
  margin-left: 0px;
  margin-top: 0px;
}

.hero-section__title {
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 3rem;
  margin: 0;
}

.hero-section__desc {
  height: 100%;
  overflow-y: auto;
  line-height: 1.35rem;
}

// Hero section media
.hero-section__image-container.has-link {
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.3s ease-out;
}

.hero-section__image-container.has-link:hover {
  opacity: 0.8;
}

.hero-section__image-container,
.hero-section__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-section__media {
  width: 100%;
  height: 100%;
  position: relative;
}

.hero-section__video {
  background: #000;
  width: 100%;
  height: 100%;
}

// Responsive oEmbed
.hero-section__iframe-container>iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

// Image Set
.image-set__container {
  display: flex;
}

.image-set--left .image-set__left {
  background-color: $image-set-bg-color;
}

.image-set--right .image-set__left {
  background-color: $image-set-bg-color-vitae;
}

.image-set--right {
  flex-direction: row-reverse;
}

.image-set__right {
  padding-top: 80px;
  padding-bottom: 80px;
  flex: 1 1 44.5%;
}

.image-set__left {
  flex: 1 1 55.5%;
  display: flex;
  padding-right: 20px;

  padding-top: 80px;
  padding-bottom: 80px;
}

.image-set__left .image-set-image__container {
  // width: calc(100% - #{$align-to-logo-margin});
  padding-right: 5px;
  // max-width: 450px;
  margin-left: $align-to-logo-margin;
  margin-right: auto;
  flex: 1 1 auto;
}

.image-set__left .image-set-image__container img {
  margin-bottom: 30px;
}

.mb-0 {
  margin-bottom: 0 !important;
}

// Tag
// Bottom Part Hero section Tag
// .bottom-part .hero-section--right .hero-section-tag__container {
//   top: 95%;
//   right: -100px;
// }

// .bottom-part .hero-section--left .hero-section-tag__container {
//   top: 97%;
//   left: 20px;
// }
.hero-section-tag__container {
  transform-origin: left;
  transform: rotate(-90deg);
  white-space: nowrap;
  font-size: 2rem;
  line-height: 2rem;
  position: absolute;
}

.hero-section-tag__container .font-size-sm {
  font-size: 1.5rem;
}

.hero-section--left .hero-section-tag__container {
  bottom: -16px;
  left: 30px;
}

.bottom-part .hero-section--right .hero-section-tag__container {
  right: -80px;
  bottom: 0;
}

// Image set tag
.image-set-tag__container {
  width: 100%;
  max-width: 50px;
  position: relative;
  flex: 0 0 50px;
}

.image-set-tag__container svg {
  position: absolute;
  top: 0; //55
  left: 0;
}

.image-set-tag__container text {
  font-family: "Cormorant Infant";
  font-size: 43.8047px;
  font-weight: 600;
}

// Image set right image
.image-set__right .image-set-image__container {
  width: 65%;
  max-width: 450px;
  position: relative;
}

.image-set__right .image-dot-container {
  position: relative;
}

.image-set--left .image-set__right .image-set-image__container {
  margin-left: 30px;
  margin-right: auto;
}

.image-set-dots {
  width: 228px;
  height: 119px;
  position: absolute;
  bottom: -30px;
  right: -30px;
}

// Image set right image --align--left
.image-set--right {
  .image-set__right .image-set-image__container {
    margin-left: auto;
    margin-right: auto; //30px
  }

  .image-set__left {
    display: flex;
    flex-flow: row-reverse;
  }

  .image-set__left .image-set-image__container {
    margin-left: 0;
    flex: 0 1 65%;
  }

  .image-set-tag__container {
    margin-left: 14.125%;
    margin-right: 30px;
  }
}

/* On screens that are 992px or less, set the background color to blue */
@media screen and (max-width: 992px) {
  .hero-section__content {
    margin-left: 0;
  }
}
</style>
